var map = {
	"./especialidades-bg.png": 6587,
	"./logo.png": 5080,
	"./orilla-rellena.webp": 2235,
	"./paquete1.png": 2807,
	"./paquete2.png": 6990,
	"./paquete3.png": 1950,
	"./paquete4.png": 4873,
	"./pizza-barra.webp": 4189,
	"./pizza-rectangular.webp": 43,
	"./servicio.webp": 7377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;